export default "__VITE_ASSET__CvhAdTwB__"